const AUTH_HAD_SESSION_KEY = "auth-had-session";
// Outlives the session so an expired or reloaded dashboard logs back into the same instance.
const LOGIN_INSTANCE_KEY = "auth-login-instance";

export const authHadSession = {
  read(): "1" | "superuser" | false {
    if (typeof window === "undefined") return false;
    try {
      const value = window.localStorage.getItem(AUTH_HAD_SESSION_KEY);
      return value === "1" || value === "superuser" ? value : false;
    } catch {
      return false;
    }
  },
  readLoginInstance(): string | null {
    if (typeof window === "undefined") return null;
    try {
      return window.localStorage.getItem(LOGIN_INSTANCE_KEY);
    } catch {
      return null;
    }
  },
  write(user: {
    is_superuser: boolean;
    login_instance_slug?: string | null;
  }): void {
    try {
      window.localStorage.setItem(
        AUTH_HAD_SESSION_KEY,
        user.is_superuser ? "superuser" : "1",
      );
      // Remember-me and pre-existing sessions report no slug; keep the one from the last real login.
      if (user.login_instance_slug) {
        window.localStorage.setItem(
          LOGIN_INSTANCE_KEY,
          user.login_instance_slug,
        );
      }
    } catch {
      // Storage may be unavailable in restricted browser contexts.
    }
  },
  clear(): void {
    try {
      window.localStorage.removeItem(AUTH_HAD_SESSION_KEY);
    } catch {
      // ignore
    }
  },
};
